import { Controller } from '@hotwired/stimulus';
import FormWriter from '../lib/form_writer';
import Actions from '../lib/actions';

export default class ChartingBaseController extends Controller {
  static {
    if (typeof window !== 'undefined') {
      window.ChartingBaseController = ChartingBaseController;
    }
  }

  static formSelector = FormWriter.formSelector;

  static resolve = Actions.resolve;

  static namespacesFor = Actions.namespacesFor;

  /**
   * Dashboards can be nested, so bind to the closest form only. This resolves
   * through the DOM rather than through a controller lookup, so a subclass
   * writes the same form wherever it is registered.
   */
  get formWriter() {
    return FormWriter.for(this.element);
  }

  theme(variable) {
    return getComputedStyle(this.element)
      .getPropertyValue(`--cd-${variable}`)
      .trim();
  }

  palette() {
    const value = this.theme('color-palette');
    if (!value) return [];

    return value.split(',').map((c) => c.trim());
  }

  resolveThemeColor(value) {
    if (
      typeof value !== 'string'
      || value.startsWith('#')
      || value.includes('(')
    ) {
      return value;
    }

    return this.theme(`color-${value.replaceAll('_', '-')}`) || value;
  }

  /**
   * Resolution goes through this.constructor so a component with genuinely
   * bespoke templating can still override the static resolver.
   */
  applyActions(actions, context) {
    Actions.apply(this.element, actions, context, { resolver: this.constructor.resolve });
  }
}
